import React, { Component } from "react";
import ClearFilterButton from "../../components/ClearFilterButton.js";
import { formatNumber } from "../../utils/formatting";
import {
  loading,
  alert,
  NavbarAdmin,
  Pagination,
  Modal,
  Select,
  DateRangeFields,
  currentLang,
  format_date,
  GET,
  GET_FILE,
  saveAs,
  profile,
  t,
  ActionIconButton,
  ACTION_ICONS,
} from "../../components/CustomComponent.js";

const PAGE_SIZE = 10;

// คั่นหลักพันด้วยลูกน้ำ (เฉพาะแสดงผลบนเว็บ) คงทศนิยมตามค่าเดิม · null/ว่าง/ไม่ใช่ตัวเลข = "-"
const formatThousands = (value) => {
  if (value === null || value === undefined || value === "") return "-";
  const str = String(value).trim();
  const match = /^(-?)(\d+)(\.\d+)?$/.exec(str);
  if (!match) return "-";
  return `${match[1]}${Number(match[2]).toLocaleString("en-US")}${match[3] || ""}`;
};

// รายงานเลขไมล์รายวันของช่าง - field ตรงกับ SNAPA-Backend modules/admin/mileage/dtos/response/mileage.response.dto.js
//   GET admin/mileage-records            -> list + pagination
//   GET admin/mileage-records/:uid       -> รายละเอียด + รายการงาน (visits) + รูป + หมายเหตุ
//   GET admin/mileage-records/filter-options -> แผนก + ช่าง (department_uid) สำหรับ dropdown ตัวกรอง
//   GET admin/mileage-records/export     -> ไฟล์ Excel .xlsx (ต้องใช้ GET_FILE เพราะเป็นไฟล์ ไม่ใช่ JSON)
// date_to ว่าง = ค้นเฉพาะวัน date_from · วันที่แสดงเป็น dd/mm/yyyy (ค.ศ.) ทุกจุด
export default class AdminMileage extends Component {
  constructor(props) {
    super(props);
    this.state = {
      filter_search: "",
      filter_department_uid: "",
      filter_technician_uid: "",
      filter_start_date: "",
      filter_end_date: "",

      data: [],
      count: 0,
      page: 1,
      data_departments: [],
      data_technicians: [],

      modal_detail: false,
      detail: null,
      // blob URL ของรูปเลขไมล์ (S3 เปิดตรงได้ 403 จึงดึงผ่าน backend ด้วย GET_FILE) photo_* = array ต่อรูป: 'loading' | 'empty' | blob URL
      photo_start: [],
      photo_end: [],
      preview_photo: null, // { src, name } รูปที่กดดูภาพใหญ่
    };
  }

  componentWillUnmount() {
    this.RevokePhotos();
  }

  RevokePhotos = () => {
    ["photo_start", "photo_end"].forEach((key) => {
      (this.state[key] || []).forEach((value) => {
        if (value && value.startsWith("blob:")) URL.revokeObjectURL(value);
      });
    });
  };

  CloseDetail = () => {
    this.RevokePhotos();
    this.photoToken = null;
    this.setState({ modal_detail: false, detail: null, photo_start: [], photo_end: [], preview_photo: null });
  };

  DownloadPhoto = async () => {
    const { preview_photo } = this.state;
    if (!preview_photo) return;
    try {
      const blob = await (await fetch(preview_photo.src)).blob();
      saveAs(blob, preview_photo.name);
    } catch (e) {
      alert("", "warning", t("warning"), e?.message || "Download failed");
    }
  };

  // ดึงรูปเลขไมล์เริ่ม/สิ้นสุด (หลายรูปต่อช่อง) เป็น blob URL ทีละรูป ไม่มีรูปหรือ 404 แสดงสถานะว่าง ไม่เด้ง alert
  LoadPhotos = async (record, type, stateKey, token) => {
    const urls = (type === "start" ? record.start_photos : record.end_photos) || [];
    if (!urls.length) return;
    this.setState({ [stateKey]: urls.map(() => "loading") });
    await Promise.all(
      urls.map(async (_, index) => {
        const result = await GET_FILE(`admin/mileage-records/${record.uid}/photo`, { type, index });
        if (this.photoToken !== token) return; // ปิด/เปิด modal ใหม่ระหว่างโหลด
        const value = result?.status && result.blob ? URL.createObjectURL(result.blob) : "empty";
        this.setState((prev) => {
          const next = [...prev[stateKey]];
          next[index] = value;
          return { [stateKey]: next };
        });
      })
    );
  };

  renderPhotoGroup = (title, photos, type) => (
    <div className="col-md-6">
      <div className="text-14 fw-bold text-dark mb-2">{title}</div>
      {photos.length === 0 ? (
        <div className="text-secondary text-14">{t("no_data")}</div>
      ) : (
        <div className="d-flex flex-column gap-2">
          {photos.map((photo, index) =>
            photo.startsWith("blob:") ? (
              <img
                key={index}
                src={photo}
                alt={`${title} ${index + 1}`}
                className="rounded-3 border w-100"
                style={{ maxHeight: "260px", objectFit: "cover", cursor: "pointer" }}
                onClick={() => this.setState({ preview_photo: { src: photo, name: `mileage_${type}_${index + 1}.jpg` } })}
              />
            ) : (
              <div key={index} className="text-secondary text-14">{photo === "loading" ? "..." : t("no_data")}</div>
            )
          )}
        </div>
      )}
    </div>
  );

  // timestamp ISO -> dd/MM/yyyy HH:mm เวลาไทย (Asia/Bangkok) ไม่ขึ้นกับ timezone เครื่อง
  formatDateTime = (value) => {
    if (!value) return "-";
    const d = new Date(value);
    if (isNaN(d.getTime())) return "-";
    const p = {};
    new Intl.DateTimeFormat("en-GB", {
      timeZone: "Asia/Bangkok", hourCycle: "h23",
      year: "numeric", month: "2-digit", day: "2-digit", hour: "2-digit", minute: "2-digit",
    }).formatToParts(d).forEach((x) => { p[x.type] = x.value; });
    const wall = new Date(Number(p.year), Number(p.month) - 1, Number(p.day), Number(p.hour), Number(p.minute));
    return format_date(wall, "dd/mm/yyyy hh:mm", currentLang());
  };

  async componentDidMount() {
    loading(false);
    await this.GetFilterOptions();
    this.Get(1);
  }

  formatDepartment = (dept) => [dept?.department_code, dept?.name].filter(Boolean).join(" - ");

  formatTechnician = (tech) => [tech?.technician_code, tech?.name].filter(Boolean).join(" - ") || "-";

  GetFilterOptions = async () => {
    const result = await GET("admin/mileage-records/filter-options");
    if (result?.status && result.data) {
      this.setState({
        data_departments: (result.data.departments || []).map((dept) => ({
          ...dept,
          value: dept.uid,
          label: this.formatDepartment(dept) || "-",
        })),
        data_technicians: result.data.technicians || [],
      });
    }
  };

  // ช่างที่แสดงใน dropdown: เลือกแผนกแล้วเหลือเฉพาะช่างแผนกนั้น
  getTechniciansInScope = () => {
    const { data_technicians, filter_department_uid } = this.state;
    return filter_department_uid ? data_technicians.filter((tech) => tech.department_uid === filter_department_uid) : data_technicians;
  };

  ChangeDepartment = (departmentUid) => {
    const { data_technicians, filter_technician_uid } = this.state;
    // ช่างที่เลือกไว้ไม่อยู่ในแผนกใหม่ -> กลับเป็น "ทั้งหมด"
    const keepTech =
      !departmentUid ||
      data_technicians.some((tech) => tech.uid === filter_technician_uid && tech.department_uid === departmentUid);
    this.setState(
      { filter_department_uid: departmentUid || "", filter_technician_uid: keepTech ? filter_technician_uid : "" },
      () => this.Get(1)
    );
  };

  // YYYY-MM-DD -> dd/mm/yyyy (ค.ศ.) ตัดจาก string ตรง ๆ ไม่ผ่าน Date กัน timezone เลื่อนวัน
  formatDmy = (value) => {
    if (!value) return "-";
    const [y, m, d] = String(value).slice(0, 10).split("-");
    return y && m && d ? `${d}/${m}/${y}` : "-";
  };

  // ช่างเลือกรถจาก technician_vehicles (snapshot ทะเบียน/ยี่ห้อ-รุ่น/ประเภทลงเลขไมล์) ชุดค่า vehicle_type จึงเหลือแค่ car/motorcycle
  // ใช้คีย์ i18n เดิมที่ technicians.js ใช้กับ technician_vehicles อยู่แล้ว ค่าที่ไม่รู้จักให้โชว์ค่าดิบแทนขึ้นค่าว่าง
  formatVehicleType = (vehicle) => {
    const labels = {
      car: "vehicle_type_car",
      motorcycle: "vehicle_type_motorcycle",
    };
    if (!vehicle) return "-";
    return labels[vehicle] ? t(labels[vehicle]) : vehicle;
  };

  // รวมทะเบียน + ยี่ห้อ/รุ่นเป็นข้อความเดียวสำหรับตาราง (คอลัมน์เดิมแคบอยู่แล้ว) ไม่มียี่ห้อ/รุ่นก็โชว์แค่ทะเบียน ไม่ลอย " · " ค้าง
  formatPlateWithModel = (item) => {
    const plate = item.vehicle_plate || "-";
    return item.vehicle_brand_model ? `${plate} · ${item.vehicle_brand_model}` : plate;
  };

  // super_user / admin-company ข้ามการตรวจสิทธิ์ระดับหน้าเหมือน PermissionRoute (users.js ใช้ pattern เดียวกัน)
  hasPermission = (key) => {
    if (["super_user", "admin-company"].includes(profile?.user_type)) return true;
    return (profile?.role?.permission || []).includes(key);
  };

  /**
   * แปลง Date จาก DateRangePicker เป็น YYYY-MM-DD ตาม local time (ไม่ใช้ toISOString เพราะเลื่อนตาม timezone)
   * @param {Date|null} date
   * @returns {string}
   */
  ToDateOnly = (date) => {
    if (!date) return "";
    const d = new Date(date);
    const month = String(d.getMonth() + 1).padStart(2, "0");
    const day = String(d.getDate()).padStart(2, "0");
    return `${d.getFullYear()}-${month}-${day}`;
  };

  Get = async (page) => {
    const { filter_search, filter_department_uid, filter_technician_uid, filter_start_date, filter_end_date } = this.state;
    loading(true);

    const result = await GET("admin/mileage-records", {
      page,
      limit: PAGE_SIZE,
      search: filter_search || "",
      department_uid: filter_department_uid || "",
      technician_uid: filter_technician_uid || "",
      date_from: filter_start_date || "",
      date_to: filter_end_date || "",
    });

    if (result?.status) {
      this.setState({
        data: result.data || [],
        count: result.pagination?.count || 0,
        page,
      });
    } else {
      this.setState({ data: [], count: 0, page });
      if (result?.message) alert("", "warning", t("warning"), result.message);
    }

    loading(false);
  };

  ResetFilter = () => {
    this.setState(
      {
        filter_search: "",
        filter_department_uid: "",
        filter_technician_uid: "",
        filter_start_date: "",
        filter_end_date: "",
      },
      () => this.Get(1)
    );
  };

  OpenDetail = async (uid) => {
    loading(true);
    const result = await GET("admin/mileage-records/" + uid);

    if (result?.status) {
      this.RevokePhotos();
      const token = {};
      this.photoToken = token;
      this.setState({ modal_detail: true, detail: result.data, photo_start: [], photo_end: [] });
      this.LoadPhotos(result.data, "start", "photo_start", token);
      this.LoadPhotos(result.data, "end", "photo_end", token);
    } else {
      alert("", "warning", t("warning"), result?.message || t("mileage_detail_failed"));
    }

    loading(false);
  };

  Export = async () => {
    const { filter_start_date, filter_end_date, filter_department_uid, filter_technician_uid, filter_search } = this.state;

    loading(true);
    const result = await GET_FILE("admin/mileage-records/export", {
      date_from: filter_start_date || "",
      date_to: filter_end_date || "",
      department_uid: filter_department_uid || "",
      technician_uid: filter_technician_uid || "",
      search: filter_search || "",
    });

    if (result?.status && result.blob) {
      const stamp = this.ToDateOnly(new Date());
      saveAs(result.blob, `mileage_${stamp}.xlsx`);
      const exported = Math.min(this.state.count || 0, 5000);
      alert("", "success", t("success"), t("mileage_export_done").replace("{count}", exported));
    } else {
      alert("", "warning", t("warning"), result?.message || t("mileage_export_failed"));
    }

    loading(false);
  };

  // เลขที่งาน/รหัสโครงการ แสดงสูงสุด 2 ชิป ที่เหลือรวมเป็น +N (ชี้เพื่อดูทั้งหมด)
  renderWorkRefs = (refs, max = 2) => {
    if (!refs || !refs.length) return <span className="text-secondary text-12">-</span>;
    return (
      <div className="d-flex flex-wrap gap-1">
        {refs.slice(0, max).map((ref) => (
          <span key={ref} className="text-12 fw-semibold text-primary bg-primary-light px-2 py-1 rounded-pill">{ref}</span>
        ))}
        {refs.length > max ? (
          <span className="text-12 fw-semibold text-secondary bg-light px-2 py-1 rounded-pill" title={refs.slice(max).join(", ")}>
            +{refs.length - max}
          </span>
        ) : null}
      </div>
    );
  };

  // สรุปตัวกรองที่ใช้อยู่ (แผนก / ช่าง / วันที่) แสดงด้านขวาของแถบ "พบ X รายการ"
  getFilterSummary = () => {
    const { data_departments, data_technicians, filter_department_uid, filter_technician_uid, filter_start_date, filter_end_date } = this.state;
    const parts = [];
    const dept = data_departments.find((d) => d.uid === filter_department_uid);
    if (dept) parts.push(`${t("mileage_filter_department")}: ${dept.label}`);
    const tech = data_technicians.find((x) => x.uid === filter_technician_uid);
    if (tech) parts.push(`${t("mileage_filter_technician")}: ${tech.name || tech.technician_code || "-"}`);
    if (filter_start_date) {
      parts.push(`${t("mileage_filter_date")}: ${this.formatDmy(filter_start_date)} – ${this.formatDmy(filter_end_date || filter_start_date)}`);
    }
    return parts.join(" · ");
  };

  renderRows() {
    const { data } = this.state;

    if (!data.length) {
      return (
        <tr>
          <td colSpan="11" className="text-center text-secondary py-5">
            {t("mileage_not_found")}
          </td>
        </tr>
      );
    }

    return data.map((item, idx) => (
      <tr key={item.uid || idx} className="border-bottom border-light bg-white pointer" onClick={() => this.OpenDetail(item.uid)}>
        <td style={{ minWidth: "150px" }}>
          <div className="text-dark text-14">{this.formatDepartment({ department_code: item.department_code, name: item.department_name }) || "-"}</div>
        </td>
        <td>
          <div className="text-dark text-14">{item.technician_code || "-"}</div>
        </td>
        <td>
          <div className="text-dark text-14 fw-semibold">{item.technician_name || "-"}</div>
        </td>
        <td>
          <div className="text-dark text-14">{this.formatDmy(item.record_date)}</div>
        </td>
        <td className="text-end">
          <div className="text-dark text-14">{formatThousands(item.start_mileage)}</div>
        </td>
        <td className="text-end">
          <div className="text-dark text-14">{formatThousands(item.end_mileage)}</div>
        </td>
        <td className="text-end">
          <div className="text-dark text-14 fw-bold">{formatThousands(item.distance_km)}</div>
        </td>
        <td>
          <div className="text-dark text-14">{this.formatPlateWithModel(item)}</div>
          <div className="text-secondary text-12">{this.formatVehicleType(item.vehicle_type)}</div>
        </td>
        <td className="text-end">
          <div className="text-dark text-14 fw-bold">{formatThousands(item.travel_cost)}</div>
        </td>
        <td>{this.renderWorkRefs(item.work_refs)}</td>
        <td className="text-center" onClick={(e) => e.stopPropagation()}>
          <div className="d-flex align-items-center gap-2 justify-content-center">
            <ActionIconButton label={t("view")} icon={ACTION_ICONS.view} variant="primary" onClick={() => this.OpenDetail(item.uid)} />
          </div>
        </td>
      </tr>
    ));
  }

  renderDetailVisits(visits) {
    if (!visits || !visits.length) {
      return <div className="text-secondary text-14">{t("no_data")}</div>;
    }

    return (
      <div className="d-flex flex-column gap-2">
        {visits.map((visit, idx) => (
          <div key={visit.uid || idx} className="border rounded-3 p-3 bg-light d-flex justify-content-between align-items-center">
            <div>
              <div className="fw-bold text-dark text-14">{visit.work_ref || visit.wo_number || "-"}</div>
              <div className="text-secondary text-12">{visit.customer_name || "-"}</div>
            </div>
            <div className="text-secondary text-12">{this.formatDateTime(visit.visit_date)}</div>
          </div>
        ))}
      </div>
    );
  }

  render() {
    const {
      data, count, page, data_departments,
      filter_search, filter_department_uid, filter_technician_uid, filter_start_date, filter_end_date,
      modal_detail, detail, photo_start, photo_end, preview_photo,
    } = this.state;

    const canExport = this.hasPermission("mileage.export");
    const technicianScope = this.getTechniciansInScope();
    const noTechInDepartment = !!filter_department_uid && technicianScope.length === 0;
    const technicianOptions = noTechInDepartment
      ? [{ value: "", label: t("mileage_no_technician_in_department"), disabled: true }]
      : [
          {
            value: "",
            label: filter_department_uid ? t("mileage_all_in_department").replace("{count}", technicianScope.length) : t("all"),
          },
          ...technicianScope.map((tech) => ({ ...tech, value: tech.uid, label: this.formatTechnician(tech) })),
        ];
    const technicianPlaceholder = noTechInDepartment
      ? t("mileage_no_technician_in_department")
      : filter_department_uid
        ? t("mileage_all_in_department").replace("{count}", technicianScope.length)
        : t("all");
    const filterSummary = this.getFilterSummary();

    return (
      <div className="w-100 min-vh-100" style={{ backgroundColor: "#F4F7FE" }}>
        <NavbarAdmin />
        <div className="body p-4 mt-3">
          {/* Header */}
          <div className="d-flex flex-wrap justify-content-between align-items-center mb-4 gap-3">
            <div>
              <h3 className="fw-bold mb-1 text-dark">{t("mileage_report")}</h3>
              <div className="text-secondary text-14">{t("mileage_desc")}</div>
            </div>
          </div>

          {/* Filter Toolbar */}
          <div className="bg-white rounded-4 shadow-sm p-4 mb-4">
            <div className="row g-3 align-items-end">
              <div className="col-md-3">
                <label className="form-label text-12 text-secondary mb-1">{t("search")}</label>
                <input
                  type="text"
                  className="form-control"
                  placeholder={t("mileage_search_placeholder")}
                  value={filter_search}
                  onChange={(e) => this.setState({ filter_search: e.target.value })}
                  onKeyDown={(e) => e.key === "Enter" && this.Get(1)}
                />
              </div>
              <div className="col-md-2">
                <label className="form-label text-12 text-secondary mb-1">{t("department")}</label>
                <Select
                  className="form-control w-100"
                  options={[{ value: "", label: t("all") }, ...data_departments]}
                  value={filter_department_uid}
                  onChange={(e) => this.ChangeDepartment(e || "")}
                  placeholder={t("all")}
                />
              </div>
              <div className="col-md-2">
                <label className="form-label text-12 text-secondary mb-1">{t("technician")}</label>
                <Select
                  className="form-control w-100"
                  options={technicianOptions}
                  value={filter_technician_uid}
                  disabled={noTechInDepartment}
                  onChange={(e) => this.setState({ filter_technician_uid: e || "" }, () => this.Get(1))}
                  placeholder={technicianPlaceholder}
                />
              </div>
              <div className="col-md-5">
                <label className="form-label text-12 text-secondary mb-1">{t("date_range")}</label>
                <div className="d-flex gap-2">
                  <DateRangeFields
                    type={currentLang()}
                    className="form-control"
                    fieldStyle={{ flex: 1, minWidth: 0 }}
                    startPlaceholder={t("start_date")}
                    endPlaceholder={t("end_date")}
                    startValue={filter_start_date}
                    endValue={filter_end_date}
                    onChange={({ start, end }) =>
                      this.setState(
                        { filter_start_date: start, filter_end_date: end },
                        () => (end || !start) && this.Get(1)
                      )
                    }
                  />
                </div>
              </div>
              <div className="col-12 d-flex gap-2 justify-content-end">
                <button className="btn btn-primary px-4 py-2 fw-bold rounded-3" onClick={() => this.Get(1)}>
                  {t("search")}
                </button>
                <ClearFilterButton onClick={this.ResetFilter} />
                {canExport ? (
                  <button className="btn btn-white border px-3 py-2 fw-bold rounded-3 d-flex align-items-center" onClick={this.Export}>
                    <span className="icon me-2">{""}</span> {t("mileage_export_btn")}
                  </button>
                ) : null}
              </div>
            </div>
          </div>

          {/* Table */}
          <div className="bg-white rounded-4 shadow-sm mb-4 overflow-hidden">
            <div className="d-flex flex-wrap justify-content-between align-items-center gap-2 px-4 pt-3 text-12 text-secondary">
              <div>
                {t("mileage_found_count").split("{count}")[0]}
                <strong className="text-dark">{formatNumber(count)}</strong>
                {t("mileage_found_count").split("{count}")[1]}
              </div>
              <div>{filterSummary}</div>
            </div>
            <div className="table-responsive">
              <table className="table table-hover align-middle mb-0" style={{ minWidth: "1400px" }}>
                <thead>
                  <tr className="text-dark fw-bold text-12 border-bottom border-light">
                    <th className="py-3 border-0">{t("department")}</th>
                    <th className="py-3 border-0">{t("employee_code")}</th>
                    <th className="py-3 border-0">{t("technician")}</th>
                    <th className="py-3 border-0 wpx-120">{t("date")}</th>
                    <th className="py-3 border-0 text-end wpx-120">{t("mileage_start")}</th>
                    <th className="py-3 border-0 text-end wpx-120">{t("mileage_end")}</th>
                    <th className="py-3 border-0 text-end wpx-120">{t("mileage_distance")}</th>
                    <th className="py-3 border-0 wpx-160">{t("license_plate")}</th>
                    <th className="py-3 border-0 text-end wpx-120">{t("mileage_travel_cost")}</th>
                    <th className="py-3 border-0">{t("mileage_work_ref")}</th>
                    <th className="py-3 border-0 text-center wpx-80">{t("actions")}</th>
                  </tr>
                </thead>
                <tbody>{this.renderRows()}</tbody>
              </table>
            </div>
          </div>

          {/* Pagination */}
          <div className="d-flex justify-content-between align-items-center mt-4 flex-wrap text-secondary text-12">
            <div>
              {t("showing")} {data.length ? formatNumber((page - 1) * PAGE_SIZE + 1) : 0}-
              {formatNumber((page - 1) * PAGE_SIZE + data.length)} {t("of")} {formatNumber(count)}
            </div>
            <Pagination
              className="mb-0"
              count={Math.ceil(count / PAGE_SIZE) || 1}
              page={page}
              showFirstButton={false}
              showLastButton={false}
              onChange={(_, nextPage) => this.Get(nextPage)}
            />
          </div>
        </div>

        {/* MODAL: DETAIL */}
        <Modal
          show={modal_detail}
          onHide={this.CloseDetail}
          centered
          size="lg"
          contentClassName="border-0 rounded-4 shadow-lg"
        >
          <Modal.Header className="border-bottom border-light px-4 py-3 bg-white" closeButton>
            <h5 className="fw-bold mb-0 text-dark">{t("mileage_detail_title")}</h5>
          </Modal.Header>
          <Modal.Body className="p-4 bg-white">
            {detail ? (
              <div className="row g-4">
                <div className="col-12">
                  <div className="row g-3 text-14">
                    {[
                      [t("department"), this.formatDepartment({ department_code: detail.department_code, name: detail.department_name })],
                      [t("technician"), this.formatTechnician({ technician_code: detail.technician_code, name: detail.technician_name })],
                      [t("date"), this.formatDmy(detail.record_date)],
                      [t("mileage_start"), formatThousands(detail.start_mileage)],
                      [t("mileage_end"), formatThousands(detail.end_mileage)],
                      [t("mileage_distance"), formatThousands(detail.distance_km)],
                      [t("license_plate"), detail.vehicle_plate],
                      [t("brand_model"), detail.vehicle_brand_model],
                      [t("vehicle_type"), this.formatVehicleType(detail.vehicle_type)],
                      [t("mileage_travel_cost"), formatThousands(detail.travel_cost)],
                      [t("mileage_job_count"), detail.visit_count ?? (detail.visits || []).length],
                    ].map(([label, value], idx) => (
                      <div className="col-md-6" key={idx}>
                        <div className="text-secondary text-12">{label}</div>
                        <div className="text-dark text-break">{value ?? "-"}</div>
                      </div>
                    ))}
                  </div>
                </div>

                <div className="col-12">
                  <div className="text-14 fw-bold text-dark mb-2">{t("mileage_visits")}</div>
                  {this.renderDetailVisits(detail.visits)}
                </div>

                {this.renderPhotoGroup(t("mileage_start_photo"), photo_start, "start")}
                {this.renderPhotoGroup(t("mileage_end_photo"), photo_end, "end")}

                {detail.note ? (
                  <div className="col-12">
                    <div className="text-14 fw-bold text-dark mb-2">{t("mileage_note")}</div>
                    <div className="text-dark bg-light rounded-3 p-3 text-14">{detail.note}</div>
                  </div>
                ) : null}
              </div>
            ) : null}
          </Modal.Body>
          <Modal.Footer className="border-top border-light px-4 py-3 bg-white d-flex justify-content-end">
            <button
              className="btn btn-white border px-4 py-2 text-dark rounded-3 fw-bold"
              onClick={this.CloseDetail}
            >
              {t("close")}
            </button>
          </Modal.Footer>
        </Modal>

        {/* MODAL: PHOTO PREVIEW */}
        <Modal
          show={!!preview_photo}
          onHide={() => this.setState({ preview_photo: null })}
          centered
          size="xl"
          contentClassName="border-0 rounded-4 shadow-lg"
        >
          <Modal.Body className="p-3 bg-white text-center">
            {preview_photo ? (
              <img src={preview_photo.src} alt={preview_photo.name} style={{ maxWidth: "100%", maxHeight: "75vh" }} />
            ) : null}
          </Modal.Body>
          <Modal.Footer className="border-top border-light px-4 py-3 bg-white d-flex justify-content-end gap-2">
            <button className="btn btn-primary px-4 py-2 rounded-3 fw-bold" onClick={this.DownloadPhoto}>
              {t("download")}
            </button>
            <button
              className="btn btn-white border px-4 py-2 text-dark rounded-3 fw-bold"
              onClick={() => this.setState({ preview_photo: null })}
            >
              {t("close")}
            </button>
          </Modal.Footer>
        </Modal>
      </div>
    );
  }
}
